<template>
  <div>
    <menu-pae />

    <div class="d-flex justify-content-center">
      <div class="row container">
        <div class="col-md-5 col-sm-12 text-sm-center">
          <nav aria-label="breadcrumb bg-white">
            <ol class="breadcrumb breadcrumb bg-white">
              <li class="breadcrumb-item"><router-link to="/workArea">Home</router-link></li>
              <li class="breadcrumb-item">Legado</li>
            </ol>
          </nav>
        </div>
      </div>
    </div>

    <div class="container-fluid mt-2">
      <filtro-pesquisa-spi class="p-2"
        :rowsNumber="10"
        :eventBusDataName="eventBusDataName"
        :eventBusPaginationName="eventBusPaginationName"/>
    </div>

    <div class="container-xl">
      <data-table-consulta-comp
        :colNames="colNames"
        :eventBusDataName="eventBusDataName"
        :eventBusDataPaginationName="eventBusPaginationName"
        :dataTableColumn="dataTableColumn"
        :colWidth="colWidth"
        :visible="false">
        <template v-slot:default="slotProps">
          <td style="text-align: center; width: 100px !important;">
            <i
              v-if="isImportado(slotProps.itemData.importacao, slotProps.more)"
              v-tooltip.auto-start="`Protocolo importado por: ${getImportacao(slotProps.itemData.importacao, slotProps.more).responsavelImportacao.titulo}`"
              class="fa fa-user fa-1-5x mr-2 text-info"
              aria-hidden="true"
            ></i>
            <i
              v-if="slotProps.itemData.arquivamento"
              v-tooltip.auto-start="'Protocolo arquivado'"
              class="fa fa-file-archive-o fa-1-5x mr-2 text-warning"
              aria-hidden="true"
            ></i>
            <i
              v-tooltip.auto-start="`Visualizar Protocolo ${slotProps.itemData.numeroProtocoloFormatado}`"
              class="fa fa-search fa-1-5x mr-2 link pr-2"
              aria-hidden="true"
              v-on:click="visualizar(slotProps.itemData.numeroProtocolo)"
            ></i>
          </td>
        </template>
      </data-table-consulta-comp>
    </div>
  </div>
</template>

<script>
import menuPae from '@/components/Menu.vue'
import filtroPesquisaSpi from '@/components/consulta-processo/FiltroPesquisaSPI.vue'
import dataTableConsultaComp from '@/components/data-table-consulta/DataTableConsultaComp'

import ProcessoElaboracaoService from '@/services/ProcessoElaboracaoService'

export default {
  name: 'legado',
  components: {
    menuPae,
    filtroPesquisaSpi,
    dataTableConsultaComp
  },

  data () {
    return {
      colNames: ['Número Protocolo', 'Origem', 'Assunto', 'Interessados', 'Ações'],
      eventBusDataName: 'consultaProtocoloSPI',
      eventBusPaginationName: 'consultaProtocoloSPIDataPagination',
      colWidth: [20, 20, 30, 20, 10],
      dataTableColumn: ['numeroProtocoloFormatado', 'origem', 'assunto.descricao', {
        column: 'interessados.[nome]',
        converter: 'interessados'
      }]
    }
  },

  created () {
    this.service = new ProcessoElaboracaoService()
  },

  methods: {
    visualizar (numeroProtocolo) {
      this.$router.push({ path: `/legado/${numeroProtocolo}` })
    },

    importar (numeroProtocolo) {
      var sessao = this.$store.getters.getDadosSessao.sessao
      this.service.importarProtocoloSPI(numeroProtocolo, sessao).then((data) => {
        this.$store.commit('MUT_NOTIFICATION', {
          alert: {
            type: 'light',
            texto: 'Começando a importação'
          },
          component: 'spi-importacao',
          params: {
            numeroProtocolo
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    },

    isImportado (importacoes, moreData) {
      if (!importacoes) {
        return false
      }

      var tenant = moreData.tenant
      for (var importacao of importacoes) {
        if (importacao.tenant === tenant) {
          return true
        }
      }
      return false
    },

    getImportacao (importacoes, moreData) {
      var tenant = moreData.tenant
      for (var importacao of importacoes) {
        if (importacao.tenant === tenant) {
          return importacao
        }
      }
      return {}
    }
  }
}
</script>
